import React, { useState, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import PortfolioCard from './PortfolioCard';
import PortfolioFilter from './PortfolioFilter';
import { portfolioData } from '../data/portfolioData';

const PortfolioGrid = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredProjects = useMemo(() => {
    if (activeCategory === 'all') {
      return portfolioData;
    }
    return portfolioData.filter(project => project.category === activeCategory);
  }, [activeCategory]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  return (
    <section className="py-20 px-4 bg-background">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            포트폴리오
          </h2>
          <p className="text-xl text-foreground/70 max-w-2xl mx-auto">
            우리가 만든 혁신적인 프로젝트들을 만나보세요
          </p>
        </motion.div>

        {/* Filter */}
        <PortfolioFilter
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
        />

        {/* Portfolio Grid */}
        <AnimatePresence mode="wait">
          <motion.div
            key={activeCategory}
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          >
            {filteredProjects.map((project, index) => (
              <PortfolioCard
                key={project.id}
                project={project}
                index={index}
              />
            ))}
          </motion.div>
        </AnimatePresence>

        {/* Empty State */}
        {filteredProjects.length === 0 && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-center py-20"
          >
            <p className="text-foreground/50 text-lg">
              해당 카테고리에 프로젝트가 없습니다.
            </p>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default PortfolioGrid;